import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import updatePageNumber from '~/helpers/pagination-helper';

var PendingTag = () => import('~/components/functional/TcVars/PendingTag.vue');

var ProductItem = () => import(
/* webpackChunkName: "product" */
'~/components/library/Product/ProductItem.vue');

export default {
  name: 'CategoryProductList',
  components: {
    ProductItem,
    PendingTag
  },
  props: {
    algolia: {
      type: Boolean,
      default: false
    },
    previousPage: {
      type: Number,
      required: true
    },
    commercial: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    isCategoryTemplate: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    productsPerPage: 'category/productsPerPage'
  })), {}, {
    trackingMeaClick() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Click_MEA',
          event_label: "".concat(this.commercial.mea_banner.title)
        }
      };
    },

    trackingMeaDisplay() {
      return typeof window !== 'undefined' ? {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Display_MEA',
          event_label: "".concat(this.commercial.mea_banner.title)
        }
      } : {};
    },

    predicateCommercial() {
      var hasCommercial = false;

      if (this.commercial) {
        hasCommercial = this.commercial.mea_banner && this.commercial.mea_banner.image;
      }

      return hasCommercial;
    }

  }),
  methods: {
    productClick(position, product) {
      var {
        query
      } = this.$route;
      query.page = Math.floor(position / this.productsPerPage) + this.previousPage;
      updatePageNumber();
      localStorage.setItem('currentProduct', JSON.stringify("product-".concat(product.reference)));

      if (this.algolia) {
        var {
          indexName
        } = this.$store.state.sharedEnv.payload.algolia;

        try {
          var payload = {
            userToken: this.$cookies.get('_ALGOLIA'),
            index: indexName,
            queryID: product.queryID,
            objectIDs: [product.reference]
          };
          window.aa('clickedObjectIDsAfterSearch', _objectSpread(_objectSpread({}, payload), {}, {
            eventName: 'product_click_on_search_page',
            positions: [product.position]
          }));
          localStorage.setItem('algoliaLastEvent', JSON.stringify(payload));
        } catch (err) {
          this.$logger.error(err);
        }
      }
    },

    trackingProduct(product) {
      if (this.algolia) {
        return {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: "Algolia_Produit_".concat(product.reference)
          }
        };
      }

      return {
        fn: 'product_list_click',
        data: {
          product_id: product.reference,
          position: product.position,
          category_click: ''
        }
      };
    }

  }
};